import styled, { css } from 'styled-components';

import { themeColor, themeToggleColor } from '~/common/utils/theme';
import { Typography } from '~/ui/components';

type PositionType = {
  justifyContent: string;
};

type CardType = {
  marginTop: boolean;
};

export const Info = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 24px;
`;

export const Position = styled.div<PositionType>`
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent};
`;

export const AgentCard = styled.div<CardType>`
  padding: 16px 26px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  background-color: ${themeColor('element.disabledBackground', { dark: 'element.secondary' })};
  border-radius: 10px;
  margin-top: ${({ marginTop }) => (marginTop ? '16px' : 0)};
`;

export const ClientCard = styled.div<CardType>`
  padding: 16px 26px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  background-color: ${themeColor('brand.secondary', { dark: 'brand.primaryAlt' })};
  border-radius: 10px;
  margin-top: ${({ marginTop }) => (marginTop ? '16px' : 0)};
`;

type DateWapperType = {
  marginTop: boolean;
};

export const DateWrapper = styled.div<DateWapperType>`
  display: flex;
  justify-content: center;
  height: 40px;
  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: 10px;
    `}
`;

export const Date = styled(Typography).attrs(({ theme, hour }) => ({
  type: 'footnote',
  element: 'label',
  weight: 400,
  color: hour
    ? themeToggleColor(theme, 'element.secondary', { dark: 'element.secondary' })
    : themeToggleColor(theme, 'element.primary', { dark: 'element.secondary' }),
}))``;

export const Text = styled(Typography).attrs(({ theme, weight }) => ({
  type: 'caption',
  element: 'label',
  weight: weight || 600,
  color: themeToggleColor(theme, 'element.primary', { dark: 'element.invert' }),
}))`
  white-space: pre-wrap;
  word-break: break-word;
`;

export const SystemNoteText = styled(Typography).attrs(({ theme }) => ({
  type: 'caption',
  element: 'label',
  weight: 400,
  color: themeToggleColor(theme, 'element.secondary', { dark: 'element.secondary' }),
}))`
  font-style: italic;
`;

export const Name = styled(Typography).attrs(({ theme }) => ({
  type: 'caption',
  element: 'label',
  weight: 600,
  color: themeToggleColor(theme, 'element.primary'),
}))``;

type CardWrapperType = {
  alignItems: string;
  marginTop: boolean;
  fullWidth: boolean;
};

export const CardWrapper = styled.div<CardWrapperType>`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: ${({ alignItems }) => alignItems};
  max-width: 80%;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
`;

type MessageWrapperType = {
  hasIcon: boolean;
};

export const MessageWrapper = styled.div<MessageWrapperType>`
  display: flex;
  gap: 8px;
  align-items: end;
  ${({ hasIcon }) =>
    !hasIcon &&
    css`
      margin-right: 44px;
    `}
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: end;
`;

export const DateCard = styled.div`
  padding: 10px 20px;
  background-color: ${themeColor('neutral.secondaryAlt')};
  border-radius: 10px;
`;

export const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${themeColor('brand.secondary', { dark: 'brand.primaryAlt' })};
  border-radius: 36px;
  min-width: 36px;
  width: 36px;
  height: 36px;
  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 10px;
  background-color: ${themeColor('neutral.secondary')};
  max-height: calc(100vh - 275px);

  &::-webkit-scrollbar {
    width: 4px;
  }
`;
export const LoadingContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const Title = styled(Typography).attrs(({ theme, size }) => ({
  type: 'paragraphSmall',
  element: 'label',
  size: size || 16,
  weight: 600,
  color: themeToggleColor(theme, 'element.primary', { dark: 'element.secondary' }),
}))`
  display: flex;
  align-items: center;
  gap: 12px;
`;
